import { Axios } from 'axios'
import { RootState } from '@/store'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import { ResponseJigyouhiSetting } from '@/repositories/fuzoku-meisai/kaikei-kijun/data'

type PostParamItem = {
  itemName: string;
  setting: Kamoku[];
}

export type PostParam = {
  zairyouhi: PostParamItem[];
  kyuyohi: PostParamItem[];
  itakuhi: PostParamItem[];
  keihi: PostParamItem[];
  uriageGenka: PostParamItem[];
  other: PostParamItem[];
}

export interface JigyouhiRepository {
  list (): Promise<ResponseJigyouhiSetting>;

  save (postParam: PostParam): Promise<void>;
}

export class JigyouhiRepositoryImpl implements JigyouhiRepository {
  constructor (http: Axios, baseUrl: string, state: RootState) {
    this.http = http
    this.baseUrl = `${baseUrl}/jigyouhi`
    this.state = state
  }

  private readonly http: Axios

  private readonly baseUrl: string

  private readonly state: RootState

  async list (): Promise<ResponseJigyouhiSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUrl,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      }
    )
    return data
  }

  async save (postParam: PostParam): Promise<void> {
    await this.http.post(this.baseUrl, postParam)
  }
}
